import useAuth from "./useAuth";

export default function usePasswordReset() {
  const { auth } = useAuth();

  return async function resetPassword(email: string) {
    if (!auth) {
      throw new Error("Auth is not initialized");
    }

    const { sendPasswordResetEmail } = await import("firebase/auth");
    await sendPasswordResetEmail(auth, email);
  };
}
